import { SET_HIDE_IMPORT_MODAL, SET_SHOW_IMPORT_MODAL } from "../../actions/import/import-form-actions";

const initialState = {
    shoModalImport: false
};

const ShowModalImportReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_SHOW_IMPORT_MODAL:
            return {
                ...state,
                error: null,
                shoModalImport : action.payload
            };
            case SET_HIDE_IMPORT_MODAL:
                return {
                    ...state,
                    error: null,
                    shoModalImport : action.payload
                };
        default:
            return state;
    }
};

export default ShowModalImportReducer;